// extracted by mini-css-extract-plugin
module.exports = {"bgBody":"style_bgBody__2AsT2","btnHome":"style_btnHome__3nqi4","container":"style_container__3NrKU","card":"style_card__16OhS","section":"style_section__1Bkq5"};